var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Liên kết tài khoản",
            "before-close": _vm.handleClose,
            visible: _vm.isOTPAuthenticationDialog,
            "close-on-click-modal": false,
            "show-close": false,
            width: "600px",
            top: "20vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isOTPAuthenticationDialog = $event
            },
            open: _vm.handleOpen,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: {
                "label-width": "140px",
                model: _vm.formData,
                "label-position": "left",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Nhập mã OTP", prop: "otp" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: { placeholder: "Nhập mã OTP" },
                    model: {
                      value: _vm.formData.otp,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "otp", $$v)
                      },
                      expression: "formData.otp",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", [
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "success",
                      size: "medium",
                      loading: _vm.loading.submit,
                    },
                    on: { click: _vm.submitForm },
                  },
                  [
                    _c("i", { staticClass: "el-icon-circle-check" }),
                    _c("span", [_vm._v("Liên kết")]),
                  ]
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            {
              staticStyle: {
                "margin-top": "20px",
                "text-align": "center",
                "font-size": "14px",
              },
            },
            [
              _vm._v(
                "\n        Trong trường hợp không nhận được mã OTP hoặc mã OTP hết hiệu lực, bạn có thể nhấn\n        "
              ),
              _c(
                "el-button",
                {
                  staticStyle: { "min-width": "100px" },
                  attrs: {
                    type: "primary",
                    size: "medium",
                    disabled: _vm.countdown > 0,
                  },
                  on: { click: _vm.resendOTP },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.countdown > 0
                          ? `Gửi lại mã (${_vm.countdown}s)`
                          : "Gửi lại mã"
                      ) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }